import React from 'react';
import s from './s.module.less';

// Channel icons exported from Figma (Patient Portal 6671:27197).
// Each leaf is drawn at its designed inset inside a 24-unit outer box, so the
// geometry survives scaling — that is why the wrapper positions the svg instead
// of just sizing it. The "Text" icon carries an SMS label inside the bubble.
export enum EChannelIcon {
    CHAT = 'chat',
    CHAT_ALT = 'chat-alt',
    MAIL = 'mail',
    DOC = 'doc',
}

const PATHS: Record<EChannelIcon, React.ReactNode> = {
    [EChannelIcon.CHAT]: (
        <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.00002 9H6.01002M10 9H10.01M14 9H14.01M19 9C19 13.4183 14.9706 17 10 17C8.46075 17 7.01173 16.6565 5.74469 16.0511L1.00002 17L2.395 13.28C1.51158 12.0423 1.00002 10.5743 1.00002 9C1.00002 4.58172 5.02945 1 10 1C14.9706 1 19 4.58172 19 9Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    [EChannelIcon.CHAT_ALT]: (
        <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V11C19 12.1046 18.1046 13 17 13H12L7 18V13H3C1.89543 13 1 12.1046 1 11V3Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    [EChannelIcon.MAIL]: (
        <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.00011 4L8.89071 9.2604C9.56251 9.70827 10.4377 9.70827 11.1095 9.2604L19.0001 4M3.00011 15H17.0001C18.1047 15 19.0001 14.1046 19.0001 13V3C19.0001 1.89543 18.1047 1 17.0001 1H3.00011C1.89554 1 1.00011 1.89543 1.00011 3V13C1.00011 14.1046 1.89554 15 3.00011 15Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    [EChannelIcon.DOC]: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
};

const INSET: Record<EChannelIcon, string> = {
    [EChannelIcon.CHAT]: s.chat,
    [EChannelIcon.CHAT_ALT]: s.chatAlt,
    [EChannelIcon.MAIL]: s.mail,
    [EChannelIcon.DOC]: s.doc,
};

type Props = {
    type: EChannelIcon;
    className?: string;
};

const ChannelIcon: React.FC<Props> = ({ type, className }) => (
    <span className={`${s.icon} ${INSET[type]} ${className || ''}`}>
        {PATHS[type]}
        {type === EChannelIcon.CHAT_ALT && <span className={s.sms}>SMS</span>}
    </span>
);

export default ChannelIcon;
